import "./StatusStyle.scss";
import { IJSLAnimation, IJSLComponent, IJSLVNode, refresh } from "jsl-render";
import { AjaxController } from "../../ajax/AjaxController";
import { MachineInfoComponent } from "./MachineInfoComponent";
import { StackPanelComponent, LoadingComponent, ExpanderComponent, IExpanderOptions } from "jsl-ui";
import { ErrorComponent } from "../common/ErrorComponent";
import { AktuellerStatusComponent } from "./AktuellerStatusComponent";
import { StatusHistoryComponent } from "./StatusHistoryComponent";
import { LandingPageInfoModel } from "../../ajax/types/LandingPageInfoModel";
import { ContactBoxComponent } from "./ContactBoxComponent";
import { FileUploadComponent } from "./FileUploadComponent";
import { RepStatusEnum } from "../../ajax/types/RepStatusEnum";
import { KaufbelegUploadComponent } from "./KaufbelegUploadComponent";

export class StatusComponent implements IJSLComponent {

  private infoObject: LandingPageInfoModel;
  private errorText: string;

  private expanderComponents: ExpanderComponent[] = [];

  public constructor(private accessToken: string) {
    this.errorText = null;
    AjaxController.GetReperaturstatus(accessToken).then((infoObject) => {
      if (infoObject != null && infoObject.Entries != null && infoObject.Objekt != null && infoObject.ProjektePositionen != null) {
        this.infoObject = infoObject;
        //console.log("ProPosId = " + this.infoObject.ProjektePositionen.ProjektPosID);
        this.initExpanders();
        AjaxController.Dummy();
      } else {
        throw "No Information found";
      }
      refresh();
    }).catch((details) => {
      this.errorText = details?.response?.data ?? details;
      refresh();
    });
  }

  public render(): IJSLVNode {

    if (this.errorText) {
      return <div>{new ErrorComponent(this.errorText)}</div>;
    }

    if (this.infoObject == null) {
      return <div class="center">{new LoadingComponent(10)}</div>;
    }

    const animation: IJSLAnimation = {
      attr: "opacity",
      from: 0,
      to: 1,
      duration: 400,
      easing: "easeInExpo"
    };
    return <div class="status-comp">{
      new StackPanelComponent([
        <div style="vertical-align: middle">
          {this.expanderComponents}
        </div>,
        new MachineInfoComponent(this.infoObject)
      ],
        {
          responsive: true,
          sizes: ["60%", "40%"],
          style: "vertical-align: middle"
        })
    }</div>;
  }


  private initExpanders() {

    // header vertikal zentrieren, aber wie?!

    const options_akt_status: IExpanderOptions = {
      header: "Aktueller Status",
      body: new AktuellerStatusComponent(this.infoObject.Entries[this.infoObject.Entries.length - 1].Text,
        this.infoObject.ProjektePositionen, this.accessToken),
      expanded: true,
    };

    const history_comp = new StatusHistoryComponent(this.infoObject.Entries);
    const options_status_history: IExpanderOptions = {
      header: "Status History",
      body: history_comp,
      expanded: true
      // onToggle: (isExpanding) => {
      //   history_comp.showAnimation = true;
      // }
    };
    const options_file_upload: IExpanderOptions = {
      header: "Laden Sie hier Fotos und Videos hoch",
      body: new FileUploadComponent(this.infoObject.Objekt, this.infoObject.ProjektePositionen, this.accessToken),
      expanded: true,
    }
    const options_kaufbeleg_upload: IExpanderOptions = {
      header: "Laden Sie Ihren Kaufbeleg hoch",
      body: new KaufbelegUploadComponent(this.infoObject.Objekt, this.infoObject.ProjektePositionen, this.accessToken),
      expanded: true,
    };
    const options_kontakt = {
      header: "Kontakt",
      body: new ContactBoxComponent(),
      expanded: false,
    };

    let akt_status_expander = new ExpanderComponent(options_akt_status);
    let status_hist = new ExpanderComponent(options_status_history);
    let kontakt_expander = new ExpanderComponent(options_kontakt);
    let file_upload;
    let kaufbeleg_upload;

    if  (this.infoObject.ProjektePositionen.USER_RepStatus === RepStatusEnum.RechnungAnfordern) {
      kaufbeleg_upload = new ExpanderComponent(options_kaufbeleg_upload);
    } else if (this.infoObject.ProjektePositionen.USER_RepStatus <= 600) {
      file_upload = new ExpanderComponent(options_file_upload); //nur für jpg, jpeg, png, "videos"
      // ganz eigener Expander (300MB maximum)
      // Anderer Pfad wo Dateien abgespeichert werden - irgendwie konfigurierbar
    }
    

    this.expanderComponents = [
      <div class="info-box">{akt_status_expander}</div>,
      kaufbeleg_upload != undefined ? <div class="info-box">{kaufbeleg_upload}</div> : undefined,
      file_upload != undefined ? <div class="info-box">{file_upload}</div> : undefined,
      <div class="info-box">{status_hist}</div>,      
    ];          
  }

}
